import type { ComponentProps, ReactNode } from 'react';

import { useNavigate } from 'react-router';

import { DashboardBackButton } from './dashboard-back-button';
import { Link } from './link';

interface IBackLinkBaseProps {
  icon?: ReactNode;
}

interface IBackLinkProps extends IBackLinkBaseProps, ComponentProps<'a'> {
  to: string;
}

interface IBackBtnProps extends IBackLinkBaseProps, ComponentProps<'button'> {
  to?: undefined;
  onClick?: () => void;
}

type BackLinkProps = IBackLinkProps | IBackBtnProps;

export const BackLink = (props: BackLinkProps) => {
  const navigate = useNavigate();

  if (props.to === undefined) {
    const { onClick, ...rest } = props;

    const handleClick = async () => {
      await navigate(-1);
    };

    return <DashboardBackButton onClick={onClick ?? handleClick} {...rest} />;
  }

  return (
    <Link className="pointer-events-auto z-50" to={props.to}>
      <DashboardBackButton icon={props.icon} />
    </Link>
  );
};
